import gsap from "gsap";

const valueCard = document.querySelectorAll('.values-block__block-content__values__card');

if(valueCard) {
    valueCard.forEach(card => {
        const cardDescription = card.querySelector('.values-block__block-content__values__card__description');
        card.addEventListener('mouseover', () => {
            gsap.to(cardDescription, {duration: 0.5, height: 'auto', ease: 'power2.inOut'});
        });
        card.addEventListener('mouseleave', () => {
            gsap.to(cardDescription, {duration: 0.5, height: 0, ease: 'power2.inOut'});
        });
    });
}